export default __webpack_public_path__ + "static/media/silly, funny.1c6af08e.jpg";